<!-- Get Started Card -->
<div class="new-card primary get-started status-card" *ngIf="statusCard?.cardType === 0">
  <div class="get-started-icon"></div>
  <div class="info-section">
    <div class="desc">
      <div *ngFor="let text of heading" [@heading]>{{text}}</div>
    </div>
    <button id="get-started" class="btn zest-btn" (click)="continue()">GET STARTED</button>
    <div class="play-video" (click)="toggleVideoPlayer()">
      <div class="video-icon"></div>
      <div>Learn how it works</div>
    </div>
  </div>
</div>
<div class="video-player-modal-background" *ngIf="showVideo">
  <div class="video-player-modal-wrapper">
    <i class="close-video-player material-icons" (click)="toggleVideoPlayer()">close</i>
    <div class="video-player">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/KVcUrs41kSc" frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</div>
<!-- Paused Journey Card -->
<div class="new-card primary paused status-card" *ngIf="statusCard?.cardType === 13">
  <div class="status-info-wrapper">
    <div class="status-icon" [style.background-image]="'url(/assets/images/ocd/paused.svg)'">
    </div>
    <div class="info-section">
      <h2 class="status-header">We will be back soon to serve you better!</h2>
      <div class="desc">Due to current challenges in the e-commerce industry, we're not accepting new applications.
      </div>
    </div>
  </div>
</div>
<!-- In-Progress/Approved/Referred/Expired card -->
<div class="new-card primary status-card" [class.expired]="statusCard?.cardType === 4 || statusCard?.cardType === 14"
  *ngIf="statusCard?.cardType !== 0 && statusCard?.cardType !== 5 && statusCard?.cardType !== 13">
  <div class="status-info-wrapper">
    <div class="status-icon"
      [style.background-image]="'url(/assets/images/ocd/' + statusCard?.progress?.icon + '.png)'">
    </div>
    <div class="info-section">
      <h2 class="status-header">{{statusCard?.progress?.header}}</h2>
      <div class="amount" *ngIf="statusCard?.clLimit">{{statusCard?.clLimit | RupeeCurrencyPipe}}
      </div>
      <div class="desc">{{statusCard?.progress?.desc}}</div>
      <button id="continue" class="btn zest-btn" [class.disabled]="statusCard?.disableCTA" *ngIf="statusCard?.progress?.cta"
        (click)="continue()">{{statusCard?.progress?.cta}}</button>
    </div>
  </div>
  <ng-container *ngIf="statusCard?.progress?.scale && statusCard?.progress?.scale !== 0">
    <zest-progress [progress]="statusCard?.progress?.scale" [message]="statusCard?.progress?.progressMsg">
    </zest-progress>
  </ng-container>
</div>